export const ENTRY_DATA_ADDITIONAL_INFORMATION_DEAL =
  "Additional Information (Deal)";

export const ENTRY_DATA_ADDITIONAL_INFORMATION_DEAL_KEYS = {
  additionalInformation: "Additional Information",
  purposeOfTheDeal: "Purpose of the Deal",
} as const;
